import React from 'react';
import { useFormContext } from 'react-hook-form';
import UIStrings from '@/Utils/UIStrings';
import { cn } from '@/lib/utils';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import { JobAdFieldTypes } from '../JobAdStepUtils';
import WingsIcon from './WingsIcon';

interface JobAdTitleProps {
    loading?: boolean;
}

function JobAdTitle({ loading = false }: JobAdTitleProps): React.JSX.Element {
    const { formState } = useFormContext();

    return (
        <RHFInput
            name={JobAdFieldTypes.Title}
            label={UIStrings.JobAdTitle}
            fieldDataCy={JobAdFieldTypes.Title}
            placeholder={loading ? '' : UIStrings.CustomizeTheJobPostTitle}
            disabled={formState.isSubmitting || loading}
            className={cn(loading && 'pl-11 disabled:opacity-100')}
            inputOverlay={loading && <WingsIcon />}
        />
    );
}

export default JobAdTitle;
